import React from "react";
import "./Network.css";

class Network extends React.Component {
  render() {
    return (
      <div className="network">
        <div className="container">
          <div className="main-network">
            <div className="left-network">
              <img src="/img/network.png" />
              <h2>Anker</h2>
            </div>
            <div className="right-network">
              <h2>
                Learn more about the AnkerPay <span>Network</span>
              </h2>
              <p>
                AnkerPay has set out on an task to create a single solution for
                all cryptocurrencies and fiat currencies that binds them into a
                single payment solution to drive adoption for individuals and
                large institutions. Email send makes it simpler, Aliases makes
                payments safer, Proof of Stake makes it more efficient,
                AnkerSwaps makes it more convenient, AnkerPlatform
                inter-operability makes it the future.
              </p>
              <a href="/ankerplatform">Learn More</a>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Network;
